module.exports = __webpack_public_path__ + "assets/img/guide-sm.e9a937a7.jpg";